import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/makerstv.webp';
import screenshot_target from '../../../images/letterfunnel/camieldutourgeerling.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Camiel Dutour Geerling"
      firstname="Camiel"
      companyname="MakersTV"
      competition="Jellysmack en AIR Media-Tech"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/camieldutourgeerling.js